import { type VirtualTableColumn } from "@snapchat/snap-design-system";
import { FolderIcon } from "@snapchat/snap-design-system-icons";

import { DecreaseText } from "../../camkit/common/components/text";
import { type LensSpace } from "../../gql-generated/types";
import { IconSection } from "../../lens/components/shared";

interface CellRenderer {
    row: {
        index: number;
    };
    data: Readonly<LensSpace[]>;
}

const getRenderer = (fn: (lensFolder: LensSpace) => React.JSX.Element) => {
    return ({ row, data }: CellRenderer) => fn(data[row.index] ?? ({} as LensSpace));
};

export const getColumns = (): VirtualTableColumn<LensSpace>[] => {
    return [
        {
            id: "icon",
            width: 72,
            Cell: getRenderer(() => (
                <IconSection data-testid="lens-row-icon">
                    <FolderIcon size={24} />
                </IconSection>
            )),
        },
        {
            id: "name",
            Header: "Name / ID",
            Cell: getRenderer((lensFolder) => <DecreaseText>{lensFolder.name}</DecreaseText>),
        },
    ];
};
